import { render, staticRenderFns } from "./TrademarkObjectionToUsYidkStatusList.vue?vue&type=template&id=62ed0467&"
import script from "./TrademarkObjectionToUsYidkStatusList.vue?vue&type=script&lang=js&"
export * from "./TrademarkObjectionToUsYidkStatusList.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkObjectionToUsYidkStatusList.vue?vue&type=style&index=0&id=62ed0467&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports